import request from '@/utils/microSeviceFormatRequest'
import onlyNasFileUploadUseRequest from '@/utils/onlyNasFileUploadUseRequest'
import { request2 } from '@/utils/microSeviceFormatRequest'

export function getTutorLessonDurationTest(start, end) {
  return request({
    url: '/api/ClassTable/GetTutorLessonDurationTest',
    data: {
      startTime: start.toDateString(),
      endTime: end.toDateString()
    },
    method: 'post'
  })
}
export function getTutorLessonDurationCancle(start, end) {
  return request({
    url: '/api/ClassTable/getTutorLessonDurationCancle',
    data: {
      startTime: start.toDateString(),
      endTime: end.toDateString()
    },
    method: 'post'
  })
}

export function getClassDetails(clid) {
  return request({
    url: '/api/ClassTable/GetClassDetails?clid=' + clid,
    method: 'post',
    timeout: 1 * 60 * 1000
  })
}

//获取学生档案
export function getStuInfoByUID(id, time) {
  return request({
    url: '/api/ClassTable/GetStuInfoByUID?uid=' + id + "&classTime=" + time,
    method: 'post'
  })
}

export function CSAssistance(param) {
  return request({
    url: '/api/ClassTable/CSAssistance',
    method: 'post',
    data: param
  })
}

export function GetClassProblem() {
  return request({
    url: '/api/ClassTable/GetClassProblem',
    method: 'post'
  })
}

export function EndClass(param) {
  return request({
    url: '/api/ClassTable/SumbitClassMomoLater',
    method: 'post',
    data: param,
    timeout: 5 * 60 * 1000
  })
}
export function leaveClassRemark(param) {
  return request({
    url: '/api/ClassTable/ClassMomoEdit',
    method: 'post',
    data: param,
    timeout: 5 * 60 * 1000
  })
}
export function newLeaveClassRemark(param) {
  return request({
    url: '/api/ClassTable/ClassNewMomoEdit',
    method: 'post',
    data: param,
    timeout: 5 * 60 * 1000
  })
}
export function leaveTrailClassRemark(param) {
  return request({
    url: '/api/ClassTable/leaveTrailClassRemark',
    method: 'post',
    data: param,
    timeout: 5 * 60 * 1000
  })
}

export async function getTeachingMaterials(UCID, isTest) {
  return request({
    url: '/api/ClassTable/GetTeachingMaterials',
    data: {
      UCID,
      isTest
    },
    method: 'post'
  })
}

export async function getAgoraCoursewarePreloadPageUrl() {
  return request({
    url: '/api/ClassTable/GetAgoraCoursewarePreloadPageUrl',
    method: 'post'
  })
}

export function setTeachingMaterials(data) {
  return request({
    url: '/api/ClassTable/SetTeachingMaterials',
    data,
    method: 'post'
  })
}

export function getMeterialRemarkDetail(data) {
  return request({
    url: '/api/ClassTable/GetMaterialRemarkDetail',
    data,
    method: 'post'
  })
}
export function JoinClassIn(clid) {
  return request({
    url: '/api/ClassTable/JoinClassIn?clid=' + clid,
    method: 'post'
  })
}
export function JoinAclassroom(clid) {
  return request({
    url: '/api/ClassTable/JoinAclassroom?clid=' + clid,
    method: 'post'
  })
}
export function JoinNetWorkAclassroom(clid, isMac) {
  return request({
    url: '/api/ClassTable/JoinNetWorkAclassroom?clid=' + clid + '&isMac=' + isMac,
    method: 'post',
    timeout: 60 * 1000,
  })
}

export function getPicturelesson(clid) {
  return request({
    url: '/api/ClassTable/getPicturelesson?clid=' + clid,
    method: 'post',
    timeout: 60 * 1000,
  })
}

export function GetTeacherToken() {
  return request({
    url: '/api/ClassTable/GetTeacherToken',
    method: 'post',
    timeout: 60 * 1000,
  })
}

export function RecordTutorClientJoinClassroom(clid) {
  return request({
    url: '/api/ClassTable/RecordTutorClientJoinClassroom?clid=' + clid,
    method: 'post'
  })
}

export function GetUserUserReportByID(usid) {
  return request({
    url: '/api/ClassTable/GetUserUserReportByID?usid=' + usid,
    method: 'post'
  })
}
export function ReportMistakeMaterial(data) {
  return request({
    url: '/api/ClassTable/ReportMistakeMaterial',
    data,
    method: 'post'
  })
}
export function GetCSPloblemDetails(clid, type) {
  return request({
    url: '/api/ClassTable/GetCSPloblemDetails?clid=' + clid + '&type=' + type,
    method: 'post'
  })
}
export function UploadAbsentPic(param) {
  return onlyNasFileUploadUseRequest({
    url: '/api/ClassTable/UploadAbsentPic',
    method: 'post',
    data: param,
    timeout: 5 * 60 * 1000
  })
}
export function AllowUploadAbsentPic(clid) {
  return request({
    url: '/api/ClassTable/AllowUploadAbsentPic?clid=' + clid,
    method: 'post'
  })
}
export function SumbitTheSameMaterials(clid, tuid, uid, classTime) {
  return request({
    url: '/api/ClassTable/SumbitTheSameMaterials',
    method: 'post',
    data: { clid, tuid, uid, classTime }
  })
}
export function GetCoursewareKnowledgePointBySId(usid) {
  return request({
    url: '/api/ClassTable/GetCoursewareKnowledgePointBySId?sId=' + usid,
    method: 'post'
  })
}
export function AutonomousCancellation(formData) {
  return onlyNasFileUploadUseRequest({
    url: '/api/ClassTable/AutonomousCancellation',
    method: 'post',
    data: formData,
    timeout: 5 * 60 * 1000
  })
}

export function TutorSelfCancel() {
  return request({
    url: '/api/ClassTable/GetTutorSelfCancel',
    method: 'post'
  })
}

export function EditLessonScore(clid, score, activityType) {
  return request({
    url: '/api/ClassTable/EditLessonScore?clid=' + clid + '&score=' + score + '&activityType=' + activityType,
    method: 'post'
  })
}

export function vipClassRemark(param) {
  return request({
    url: '/api/ClassTable/VipClassRemark',
    method: 'post',
    data: param,
    timeout: 5 * 60 * 1000
  })
}

export function knowledgePointsClassRemark(param) {
  return request({
    url: '/api/ClassTable/KnowledgePointsClassRemark',
    method: 'post',
    data: param,
    timeout: 5 * 60 * 1000
  })
}

export function getClassProblemIncludeChildren(param) {
  return request({
    url: `/api/ClassTable/GetClassProblemIncludeChildren?classTool=${param}`,
    method: 'post'
  })
}

//获取老师本周剩余可取消课时数
export function getRemainingCancelCountOfThisWeek() {
  return request({
    url: '/api/ClassTable/GetRemainingCancelCountOfThisWeek',
    method: 'post'
  })
}

// 口语测评内容
export function getMasterSpokenDetailsByCLID(clid) {
  return request({
    url: '/api/ClassTable/GetMasterSpokenDetailsByCLID?clid=' + clid,
    method: 'post'
  })
}
// 提交口语测评成绩
export function submitMasterRecordByCLID(data) {
  return request({
    url: '/api/ClassTable/SubmitMasterRecordByCLID',
    method: 'post',
    data: data
  })
}
// 
export function getTutorSelfCancelTest() {
  return request({
    url: '/api/ClassTable/GetTutorSelfCancelTest',
    method: 'post'
  })
}

// 获取昨天的课时数据
export function getTutorRealTimeClassInfo() {
  return request({
    url: '/api/ClassTable/GetTutorRealTimeClassInfo',
    method: 'post'
  })
}

// 获取当前周的课时统计数据
export function getTutorRealTimeClassByWeek() {
  return request({
    url: '/api/ClassTable/GetTutorRealTimeClassByWeek',
    method: 'post'
  })
}

// 
export function getIsDivertUser(uid) {
  return request({
    url: '/api/ClassTable/GetIsDivertUser?uid=' + uid,
    method: 'post'
  })
}
// 
export function getMaterialsByDivertUser(clid, uid) {
  return request({
    url: '/api/ClassTable/GetMaterialsByDivertUser?clid=' + clid + '&uid=' + uid,
    method: 'post'
  })
}
// 
export function setMaterialsByDivertUser(clid, uid, sid, catId) {
  return request({
    url: '/api/ClassTable/SetMaterialsByDivertUser?clid=' + clid + '&uid=' + uid + '&sid=' + sid + '&catId=' + catId,
    method: 'post'
  })
}

// 获取备课详情
export function getLessonPlanInfo(clid) {
  return request({
    url: '/api/ClassTable/GetLessonPlanInfo?clid=' + clid,
    method: 'post'
  })
}

// 保存备课内容
export function saveLessonPlanInfo(param) {
  return request({
    url: '/api/ClassTable/SaveLessonPlanInfo',
    method: 'post',
    data: param
  })
}

// 进入课程详情时判断当前是否学生过往好/差评实验用户
export function isCurrentUserInPastLabelExperiment(uid) {
  return request({
    url: '/api/ClassTable/IsCurrentUserInPastLabelExperiment?uid=' + uid,
    method: 'post'
  })
}

// 获取学生过往好/差评标签
export function getCurrentStudentAppraisalItemSuggestionList(uid) {
  return request({
    url: '/api/ClassTable/GetCurrentStudentAppraisalItemSuggestionList?uid=' + uid,
    method: 'post'
  })
}

// 进入课程详情埋点
export function insertClassDetailStayTimeLog(clid) {
  return request({
    url: '/api/ClassTable/InsertClassDetailStayTimeLog?clid=' + clid,
    method: 'post'
  })
}

// 离开课程详情埋点
export function updateClassDetailStayTimeLog(clid) {
  return request({
    url: '/api/ClassTable/UpdateClassDetailStayTimeLog?clid=' + clid,
    method: 'post'
  })
}
// 指定老师可点击
export function IsDidiDutyTutor() {
  return request({
    url: '/api/ClassTable/IsDidiDutyTutor',
    method: 'post'
  })
}

// 过往差评提醒老师实验，点击建议按钮埋点
export function insertSuggestClickLog(clid, suggestId) {
  return request({
    url: '/api/ClassTable/InsertSuggestClickLog?clid=' + clid + '&suggestId=' + suggestId,
    method: 'post'
  })
}
// 获取课后评价展示上课精彩瞬间截图
export function GetWonderfulPictures(clid) {
  return request({
    url: `/api/ClassTable/GetWonderfulPictures?clid=${clid}`,
    method: 'post'
  })
}

export function checkCategory(cateId, cateName, uid, classTime) {
  return request({
    url: '/api/ClassTable/CheckCategory?cateId=' + cateId + '&cateName=' + cateName + '&uid=' + uid + '&classTime=' + classTime,
    method: 'post'
  })
}
// 好差评埋点
export function InsertStudentAppraisalPopupLog(cateId, time, type) {
  return request({
    url: '/api/ClassTable/InsertStudentAppraisalPopupLog?clid=' + cateId + '&staySeconds=' + time + '&isRead=' + type,
    method: 'post'
  })
}
// 声网教室内查询是否存在备课信息
export function GetTutorLessonPlanState(clid) {
  return request({
    url: `/api/ClassTable/GetTutorLessonPlanState?${clid}`,
    method: 'post',
  })
}
// 声网教室接口
export function SearchCourseInfoByName(subjectName, currentPage, pageSize) {
  return request2({
    url: '/api/NetlessRTCRoom/SearchCourseInfoByName?subjectName=' + subjectName + '&currentPage=' + currentPage + '&pageSize=' + pageSize,
    method: 'post',
    baseURL: process.env.VUE_APP_API_HOST_ACCOREAPI
  })
}
// 声网教室接口2
export function ChangeSidByLessonInfo(param) {
  return request2({
    //url: '/api/NetlessRTCRoom/ChangeSidByLessonInfo?clid='+clid+'&changedSid='+changedSid+'&userid='+userid+'&userType='+userType+'&classToolType='+classToolType+'&remark='+remark,
    url: '/api/NetlessRTCRoom/ChangeSidByLessonInfo',
    method: 'post',
    data: param,
    baseURL: process.env.VUE_APP_API_HOST_ACCOREAPI
  })
}


export function saveMaterialResonlist(param) {
  return request({
    url: '/api/ClassTable/SaveMaterialResonlist',
    method: 'post',
    data: param
  })
}

//获取smsnotice状态
export function getTrialClassSMSNoticeStatus(clid) {
  return request({
    url: '/api/ClassTable/GetTrialClassSMSNoticeStatus?clid=' + clid,
    method: 'post',
  })
}

//发送smsnotice
export function sendTrialClassSMSNotice(clid) {
  return request({
    url: '/api/ClassTable/SendTrialClassSMSNotice?clid=' + clid,
    method: 'post',
  })
}

//获取老师取消权益信息
export function getCancelRightsInfo() {
  return request({
    url: '/api/ClassTable/GetCancelRightsInfo',
    method: 'post'
  })
}

//学生档案埋点
export function AddTutorEventLog(val, param) {
  return request({
    url: '/api/ClassTable/AddTutorEventLog',
    method: 'post',
    data: {
      eventEnum: val,
      response: param
    },
  })
}

//学伴课详情
export function GetSmallClassInfo(clid) {
  return request({
    url: '/api/ClassTable/GetSmallClassInfo?sclid=' + clid,
    method: 'post',
  })
}

export function JoinSmallClassRoom(clid) {
  return request({
    url: '/api/ClassTable/JoinSmallClassRoom?sclid=' + clid,
    method: 'post',
  })
}

//获取AI试课报告
export function GetAIReportSummary(clid) {
  return request({
    url: `/api/ClassTable/GetAIReportSummary?clid=${clid}`,
    method: 'post',
  })
}

export function CreateTestClassInSDKCourse(tuid) {
  return request({
    url: `/api/ClassTable/CreateTestClassInSDKCourse?tuid=${tuid}`,
    method: 'post'
  })

}

export function GetStartTestClassInInfo(tuid) {
  return request({
    url: `/api/ClassTable/GetStartTestClassInInfo?tuid=${tuid}`,
    method: 'post'
  })

}

export function RecordUserBehavior(data) {
  return request2({
    headers: {
      'Content-Type': 'application/json',
      'X-Secret': '703E2AEF23C7EE2F90077AF25033CDC698F56D8233169094'
    },
    url: `/api/TeacherSystem/TutorWeb/AddCustomData`,
    method: 'post',
    data,
    baseURL: process.env.VUE_APP_API_HOST_BEHAVIOR
  })
}

//获取老师email
export function GetTutorAccount() {
  return request({
    url: `/api/account/GetTutorAccount`,
    method: 'post'
  })

}

//获取教室ID
export function GetTencentRoomID(clid) {
  return request({
    url: `/api/ClassTable/GetTencentRoomID?clid=${clid}`,
    method: 'post'
  })

}

//获取培训内容
export function GetCourseTrainingContent(trainingTag,clid) {
  return request({
    url: `/api/ClassTable/GetCourseTrainingContentAndRead`,
    method: 'post',
    data:{
      TrainingTag: trainingTag,
      CLID: clid
    },
  })

}

